module.exports = __webpack_public_path__ + "img/loguito.fc2d89c5.png";